module.exports = __webpack_public_path__ + "img/chofer.fecfb39f.fecfb39f.png";